import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { spotlightQueryKey, spotlightsQueryKey } from '../../../../queries/employee-spotlights';
import { EmployeeSpotlight } from '../../../../schemas/spotlight';

/**
 * Hook to invalidate spotlight query cache when a spotlight generation completes.
 * Used by AppEvents to handle EmployeeSpotlightGenerationComplete websocket events.
 */
export const useSpotlightCacheInvalidation = () => {
	const queryClient = useQueryClient();

	return useCallback(
		(data: { spotlight_id?: string }) => {
			const spotlight_id = data.spotlight_id;
			if (!spotlight_id) {
				return;
			}

			// Invalidate and refetch spotlight queries so the UI updates
			queryClient.invalidateQueries({ queryKey: spotlightQueryKey(spotlight_id) });
			queryClient.refetchQueries({ queryKey: spotlightQueryKey(spotlight_id), type: 'active' });

			// Also invalidate the list query if we have the userId cached
			const cachedSpotlight = queryClient.getQueryData<EmployeeSpotlight>(spotlightQueryKey(spotlight_id));
			if (cachedSpotlight?.userId) {
				queryClient.invalidateQueries({ queryKey: spotlightsQueryKey(cachedSpotlight.userId) });
			}
		},
		[queryClient]
	);
};
